module.exports = __webpack_public_path__ + "img/teams-tab-banner.e7efb9ed.png";